import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import clsx from "classnames";
import { useTranslation } from 'react-i18next';
import _ from "lodash";
import "./styles.css";
import "./example-styles.css";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";


// import component
import OrderPlace from "./OrderPlace";
import MarketPrice from "./MarketPrice";
import OrderBook from "./OrderBook";
import UserOrderList from "./UserOrderList";
import MarketPriceTable from "./Markerpricetable";

import Chart from "./Chart";
import RecentTrade from "./RecentTrade";

const ShowcaseLayout = (props) => {
  const orderBookRef = useRef();
  const { t, i18n } = useTranslation();
  // state
  const [expandScreen, setExpandScreen] = useState("");

  const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
  const [compactType, setCompactType] = useState("vertical");
  const [mounted, setMounted] = useState(false);
  const [layouts, setLayouts] = useState({
    lg: props.initialLayout,
  });

  // function

  const onBreakpointChange = (breakpoint) => {
    setCurrentBreakpoint(breakpoint);
  };

  useEffect(() => {
    setMounted(true);
  }, []);



  return (
    <div>
      <div className="container-fluid">
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            {/* <div className="static topOverview gridItemYellow">
                  <MarketPrice />
                </div> */}
            <div className="spotInnerContainer">
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={9} className="spotInnerContainer_first_parent">
                  <GridContainer>

                    <GridItem xs={12} sm={12} md={12} lg={4} className="spotInnerContainer_first_parent_childone">
                      <div className="tradeChartMain gridItemYellow">
                        <MarketPriceTable />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={8} className="spotInnerContainer_first_parent_childtwo">
                      <div className="tradeChartMain gridItemYellow">
                        <MarketPrice />
                        <div className="tradeChart">
                          <Chart />
                        </div>
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div className="tradeChartMain gridItemYellow">
                        <UserOrderList />
                      </div>
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={12} lg={3} className="spotInnerContainer_second_parent">
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div className={clsx("orderPlaceMain gridItemYellow", {
                        fullScreen: expandScreen === "orderPlace",
                      })}
                      >
                        <OrderPlace
                          setExpandScreen={setExpandScreen}
                          expandScreen={expandScreen}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <div className="gridItemYellow table_tabs_new">
                        <ul class="nav nav-tabs">
                          <li class="active"><a data-toggle="tab" className="active" href="#home">{t('ORDER_BOOK')}</a></li>
                          <li><a data-toggle="tab" href="#menu1">{t('RECENT_TRADE')}</a></li>

                        </ul>
                        <div class="tab-content">
                          <div id="home" class="tab-pane fade in active show">
                            <div className={clsx("orderBookMain ", {
                              fullScreen: expandScreen === "orderBook",
                            })}
                            >
                              <OrderBook
                                ref={orderBookRef}
                                layout={
                                  props.initialLayout &&
                                  props.initialLayout.find((el) => el.i === "1")
                                }
                                setExpandScreen={setExpandScreen}
                                expandScreen={expandScreen}
                              />
                            </div>
                          </div>
                          <div id="menu1" class="tab-pane fade">
                            <div className={clsx("recentTradeMain ", {
                              fullScreen: expandScreen === "recentTrade",
                            })}
                            >
                              <RecentTrade
                                setExpandScreen={setExpandScreen}
                                expandScreen={expandScreen}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </GridItem>
                  </GridContainer>
                </GridItem>

              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>

    </div>
  );
};



export default ShowcaseLayout;